export default __webpack_public_path__ + "static/media/iconMoney.7f0271d1.svg";